"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _richTextField = require("../../lib/richTextField");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SearchModal = props => {
  var {
    linkUrl,
    linkTarget,
    linkAlt
  } = (0, _linkFieldSrc.linkFieldSrc)(props.scfields.loginLink.value);
  var {
    caLink,
    caLinkTarget,
    caLinkAlt
  } = (0, _linkFieldSrc.linkFieldSrc)(props.scfields.accountLink.value);
  var handlehide = () => {
    props.handlehide();
  };
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    show: props.showModal,
    onHide: handlehide,
    backdrop: true,
    size: "md"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: handlehide
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, (0, _richTextField.parseHTML)(props.scfields.modalbody), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Form:")), /*#__PURE__*/_react.default.createElement("a", {
    href: props.itemlink
  }, "Open ".concat(props.itemtitle)), /*#__PURE__*/_react.default.createElement("p", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: handlehide,
    className: "btn btn-link",
    "data-dismiss": "modal"
  }, "Cancel")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-5"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "btn btn-secondary searchmodal-wrap",
    href: caLink
  }, "Create Account")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "btn btn-primary",
    href: linkUrl
  }, "Log In")))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Footer, null));
};
var _default = exports.default = SearchModal;